import { render, staticRenderFns } from "./DeliveryChallanItemEditBatch.vue?vue&type=template&id=452f97dc&scoped=true&"
import script from "./DeliveryChallanItemEditBatch.vue?vue&type=script&lang=js&"
export * from "./DeliveryChallanItemEditBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f97dc",
  null
  
)

export default component.exports